import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchFormComponent } from '../../search-form/search-form.component';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from '../shared.module';
import { TypeaheadModule } from "ngx-bootstrap";
import { SearchResultComponent } from "../../search-result/search-result.component";
import { SearchFormService } from "../services/search-form.service";
import { VerificationService } from "../services/verification.service";


@NgModule({
    declarations: [
        SearchFormComponent,
        SearchResultComponent
    ],
    imports: [
        CommonModule,
        BrowserModule,
        SharedModule,
        TypeaheadModule.forRoot()
    ],
    exports: [
        SearchFormComponent,
        SearchResultComponent
    ],
    providers: [SearchFormService, VerificationService]
})
export class SearchModule {}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/search/search.module.ts